export default __webpack_public_path__ + "static/media/1899.8d05f69f.png";